'use client';
import { useRef, useState } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Button from '@/components/Button';
import { PlayCircleIcon } from '@heroicons/react/20/solid';
import { ModalVideoPlayer } from '@/components/ModalVideoPlayer';

export function WorkingAtGradle() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      videoRef.current,
      {
        scale: 0.7,
      },
      {
        scale: 1,
        scrollTrigger: {
          trigger: videoRef.current,
          start: 'top-=100px 60%',
          end: '70% 60%',
          scrub: true,
        },
      },
    );
  });

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <section id="working-at-gradle" className="py-section h-screen-with-nav relative bg-gray-1 text-white">
      <div className="max-w-section flex h-full flex-col items-center justify-center">
        <div className="px-section z-10 flex max-w-[49rem] flex-col items-center gap-8 text-center">
          <h2 className="text-h2">Working at Gradle</h2>
          <p className="text-body">
            Whether in Sales, Engineering, Product, Design, Marketing, or Operations, you’ll become part of a company
            that prioritizes collective goals and continuous improvement. You’ll learn from your team members’ diverse
            perspectives, contribute to our strategic direction, and work on a product that meaningfully improves the
            experience of developers everywhere.
          </p>
          <Button
            onClick={() => {
              setIsOpen(true);
            }}
            variant="ghost-light"
          >
            <PlayCircleIcon className="mr-2 size-5" /> Get to know us
          </Button>
        </div>
      </div>
      <ModalVideoPlayer
        isOpen={isOpen}
        videoLink="https://www.youtube.com/watch?v=Y49SMBsDLIA&feature=youtu.be"
        onClose={closeModal}
      />
      <video ref={videoRef} className="absolute inset-0 size-full object-cover" autoPlay loop muted playsInline>
        <source src="/assets/videos/careers/montage.mp4" type="video/mp4" />
        <source src="/assets/videos/careers/montage.webm" type="video/webm" />
      </video>
      <div className="absolute inset-0 size-full bg-gray-1/60"></div>
    </section>
  );
}
